import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3f77f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "content flex-col-bwn" }
const _hoisted_3 = {
  key: 0,
  class: "props"
}
const _hoisted_4 = { class: "flex-wrap fx-1 ml_5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-ct" }
const _hoisted_7 = { class: "sku-img" }
const _hoisted_8 = ["src"]

import { t } from '@/plugins/i18n'
import {
  ref,
  watch,
  reactive,
  computed,
  onUnmounted
} from 'vue'
import { useRequest } from '@/util/useLoading'
import { productDetail } from '@/apis/search'
import { arr2map } from '@/plugins/utils'
// import useEdited from '@/util/useEdited'
import { replaceSku } from '@/apis/shopcart'


export default /*#__PURE__*/_defineComponent({
  props: ['data'],
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props
const [loading, api] = useRequest(productDetail)




const data = reactive(props.data)
const visible = ref(false)
const propKeys: any = ref([])
const img = computed(() => {
  return skuMap.value.get(propKeys.value.join(';'))?.productSkuImg || props.data.productMainImg
})

const product: any = ref(null)
const skuMap: any = ref(new Map())
const isdisabled = (v: string, i: number) => {
  const key = [...propKeys.value.slice(0, i), v, ...propKeys.value.slice(i + 1)].join(';')
  if (key.split(';')?.length === product.value.productPropGroupList?.length && !skuMap.value.get(key)) {
    return true
  }
  return !((skuMap.value.get(key)?.productStockQuantity) !== 0)
}

const commit = () => {
  console.log(propKeys.value)
  const key = propKeys.value.join(';')
  if (key !== props.data.productProperties) {
    replaceSku({
      cartId: props.data.cartId,
      productSku: skuMap.value.get(key).productSku
    }).then(() => {
      emit('update')
    })
  }
  visible.value = false
}
watch(visible, () => {
  if (visible.value) {
    propKeys.value = props.data.productProperties.split(';')
    if (!product.value) {
      api({ productCode: props.data.productCode }).then(async (res:any) => {
        if (res.success) {
          product.value = res.data
          skuMap.value = arr2map(
            res.data.skuList,
            (v: any) => v.productProperties
          )
        }
      })
    }
  }
})

const show = () => {
  if (!visible.value) {
    setTimeout(() => {
      visible.value = true
    }, 0)
  }
}

const hide = (e: any) => {
  if (visible.value) {
    let tar = e.target
    while (tar && tar.id !== data.productSku) {
      tar = tar.parentNode
    }
    if (tar === null) {
      visible.value = false
    }
  }
}

document.body.addEventListener('click', hide)
onUnmounted(() => document.body.removeEventListener('click', hide))

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    offset: 4,
    placement: "bottom",
    width: 520,
    teleported: true
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", { onClick: show }, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { "max-height": 300 }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            id: _unref(data).productSku,
            class: "flex"
          }, [
            _createElementVNode("div", _hoisted_2, [
              (product.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.productPropGroupList, (v, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: v.type,
                        class: "flex"
                      }, [
                        _createElementVNode("label", null, _toDisplayString(v.type), 1),
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.props, (p) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["flex-center item-prop btn", {
                  disabled: isdisabled(p.propKey, i),
                  active: p.propKey === propKeys.value[i]
                }]),
                              key: p.propKey,
                              onClick: ($event: any) => (isdisabled(p.propKey, i) || (propKeys.value[i] = p.propKey))
                            }, _toDisplayString(p.propValue), 11, _hoisted_5))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  size: "small",
                  text: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: commit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                referrerPolicy: "no-referrer",
                src: _unref(img),
                alt: ""
              }, null, 8, _hoisted_8)
            ])
          ], 8, _hoisted_1), [
            [_directive_loading, _unref(loading)]
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})